import { ActionButton, ActionForm, Load, Page, Section, Table } from '../ui/kit';

// The competitor ad watch (src/competitors/ads.ts): who is watched on Meta, the ads they run now with how long
// each has run (30+ days: what works for them), and the weekly summaries the Monday job writes and sends to Telegram.

const day = (v: string | null) => (v ? new Date(v).toISOString().slice(0, 10) : '—');
const list = (xs: string[]) => (xs?.length ? xs.join(', ') : '—');

export default function CompetitorAds() {
  return (
    <Page title="Competitor ads" prefix="Outlevo · Admin" actions={<ActionButton path="/ops/competitor-ads/run" label="Run now" />}>
      <Load<any> path="/ops/competitor-ads">{(d) => (
        <>
          <p className="small muted">Read every Monday from the Meta Ad Library API. UK and EU ads only (Meta's Ad Library API has no US commercial ads).
            {d.configured === false ? ' Not configured: set META_AD_LIBRARY_TOKEN on the worker (F28 spec, “Competitor ad watch”).' : ''}</p>

          <Section title="Watched advertisers" actions={<ActionForm title="Watch an advertiser" button="Add advertiser" path="/ops/competitor-ads/advertisers" fields={[
            { name: 'name', label: 'Name', required: true },
            { name: 'page_id', label: 'Facebook page id', required: true, pattern: '[0-9]{1,30}', help: 'In the Ad Library, open the advertiser and copy the page id (digits) from the URL’s view_all_page_id.' }]} />}>
            <Table rows={d.advertisers} columns={[
              { key: 'name', label: 'Advertiser', render: (a: any) => <a href={`https://www.facebook.com/ads/library/?active_status=active&ad_type=all&country=ALL&view_all_page_id=${a.page_id}`} target="_blank" rel="noreferrer">{a.name}</a> },
              { key: 'page_id', label: 'Page id' },
              { key: 'active_ads', label: 'Active ads' }, { key: 'total_ads', label: 'Seen' },
              { key: 'last_run_at', label: 'Last read', render: (a: any) => <span>{day(a.last_run_at)}<br /><small className="muted">{a.last_status ?? 'not read yet'}</small></span> },
              { key: 'id', label: '', render: (a: any) => <ActionButton method="PUT" path={`/ops/competitor-ads/advertisers/${a.id}`} body={{ active: !a.active }} label={a.active ? 'Stop watching' : 'Watch again'} /> },
            ]} empty="Nobody watched." />
          </Section>

          <Section title="Weekly summaries">
            <Table rows={d.reports} columns={[
              { key: 'week_start', label: 'Run', render: (r: any) => day(r.week_start) },
              { key: 'status', label: 'Status' },
              { key: 'summary', label: 'Summary', render: (r: any) => <span>{r.ai_summary ? <>{r.ai_summary}<br /></> : null}<small className="muted" style={{ whiteSpace: 'pre-line' }}>{r.summary}</small></span> },
            ]} empty="No run yet: the first runs on Monday at 07:00 UTC, or press Run now." />
          </Section>

          <Section title="Ads running now">
            <Table rows={d.ads} columns={[
              { key: 'advertiser', label: 'Advertiser' },
              { key: 'title', label: 'Ad', render: (a: any) => <span>{a.title ? <strong>{a.title}<br /></strong> : null}<small>{a.body ?? '—'}</small></span> },
              { key: 'days_running', label: 'Running', render: (a: any) => <span className={a.days_running >= 30 ? 'good' : ''}>{a.days_running} days{a.days_running >= 30 ? ' · winner' : ''}</span> },
              { key: 'start_date', label: 'Since', render: (a: any) => day(a.start_date ?? a.first_seen) },
              { key: 'publisher_platforms', label: 'Where', render: (a: any) => <small>{list(a.publisher_platforms)}<br /><span className="muted">{list(a.countries)}</span></small> },
              { key: 'ad_id', label: '', render: (a: any) => <a href={a.library_url} target="_blank" rel="noreferrer">Ad Library</a> },
            ]} empty="No active ads seen." />
          </Section>
        </>
      )}</Load>
    </Page>
  );
}
